import React from "react";
import { BsGithub } from "react-icons/bs";
import { HiOutlineExternalLink } from "react-icons/hi";
import { motion } from "framer-motion";
const Project = ({ data }) => {
  const capitalize = (string) => {
    return string
      .trim()
      .split(" ")
      .map((elm) => elm[0].toUpperCase() + elm.slice(1))
      .join(" ");
  };

  const handelColor = (e) => {
    e.currentTarget.querySelector("img").style.filter = "grayscale(0%)";
  };
  const grayColor = (e) => {
    e.currentTarget.querySelector("img").style.filter = "";
  };

  return (
    <motion.div
      onMouseEnter={(e) => handelColor(e)}
      onMouseLeave={(e) => grayColor(e)}
      whileHover={{ scale: 1.05 }}
      className="w-[330px] ph:w-[200px] h-full mx-auto   md:w-full shadow-3xl overflow-hidden border-2 rounded-lg dark:bg-white"
    >
      <div className="flex   flex-col p-2 gap-2 h-full 	 ">
        <div className="p-1 z-10 	">
          <a href={data.link} target="_blank" rel="noreferrer">
            <img
              loading="lazy"
              src={require(`../data/pictures/${data.img}`)}
              alt=""
              className=" rounded-lg   h-44 ph:h-32	dark:grayscale	 cursor-pointer "
            />
          </a>
        </div>

        <div className="flex flex-col gap-2 px-2 mb-2">
          <h1 className="font-bold capitalize text-neutral-900 ph:text-sm">
            {capitalize(data.title)}
          </h1>
          <p className="text-sm text-gray-400 dark:text-neutral-400 ph:text-xs">
            {data.introduction}
          </p>
          <div className="flex items-center gap-1 flex-wrap">
            {data.tools.map((elm, i) => (
              <span className="tool" key={i}>
                {elm}
              </span>
            ))}
          </div>
        </div>
        <div className="p-2 mt-auto flex items-center justify-end w-full gap-4">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={data.repository}
            className="text-gray-500 hover:text-emerald-400   "
          >
            <BsGithub size={25} />
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={data.link}
            className="text-gray-500 hover:text-emerald-400  "
          >
            <HiOutlineExternalLink size={25} />
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default Project;
